const content: { [key: string]: any } = {
  permissionRoleGroupList: 'Permission Role Groups',
};

export default content;
